import request from '@/utils/request'

// 获取可见的前台菜单（公开接口，不发 token）
export function getVisibleMenus() {
    return request({
        url: '/swx/customer/frontendMenu/visible',
        method: 'get',
        noAuth: true
    })
}
